import React from "react";
import classNames from "classnames";
import { Transaction } from "@common/types/transaction";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { TransactionAccountColumnContent } from "../ListItem/TransactionAccountColumnContent";
import { TransactionAmount } from "../TransactionAmount";
import styles from "./TransactionSplitCard.module.scss";
import { TransactionDescriptionContent } from "./transactionContent/TransactionDescriptionContent";
import { TransactionEntityContent } from "./transactionContent/TransactionEntityContent";
import { AmountDisplayFormat } from "./TransactionSplitCard.lib";

interface Props {
    transaction: Transaction;
    showEntity?: boolean;
    className?: string;
    amountDisplayFormat?: AmountDisplayFormat;
}

export const TransactionSplitCard: React.FC<Props> = ({
    transaction,
    showEntity,
    className,
    amountDisplayFormat = AmountDisplayFormat.COLOR,
}) => (
    <div className={classNames(styles.transaction, className)}>
        <div className={styles.transactionDate}>
            {transaction.dateOnly
                ? formatDateOnly(transaction.dateOnly)
                : formatBusinessDate(transaction.date)}
        </div>
        <TransactionDescriptionContent
            transaction={transaction}
            alwaysShowBankDescription
        />
        <TransactionAccountColumnContent transaction={transaction} size="xs" />
        <TransactionAmount
            className={styles.transactionAmount}
            transaction={transaction}
            color={amountDisplayFormat === AmountDisplayFormat.COLOR}
            addSign={amountDisplayFormat === AmountDisplayFormat.SIGN}
        />
        {showEntity && <TransactionEntityContent transaction={transaction} />}
    </div>
);
